import { render, staticRenderFns } from "./HomePositionsList.vue?vue&type=template&id=67986fd8&scoped=true"
import script from "./HomePositionsList.js?vue&type=script&lang=js&external"
export * from "./HomePositionsList.js?vue&type=script&lang=js&external"
import style0 from "./HomePositionsList.scss?vue&type=style&index=0&id=67986fd8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67986fd8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotPositionsListItems: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/PositionsListItems/PositionsListItems.vue').default})
